import React from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import axios from 'axios';

const UserList = ({ users, fetchUsers }) => {
  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://localhost:5000/api/users/${id}`);
      fetchUsers();
    } catch (err) {
      console.error('Error eliminando usuario:', err);
    }
  };

  return (
    <ListGroup className="mt-4">
      {users.map(user => (
        <ListGroup.Item key={user.id}>
          {user.name} - {user.email} ({user.role})
          <Button variant="danger" size="sm" onClick={() => handleDelete(user.id)} className="ms-3">
            Eliminar
          </Button>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default UserList;